"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  ops: {
    createName: '经办人',
    createTime01: '经办时间',
    settleDate: '收/付款日期',
    settleAmount: '已收/付金额',
    baseAmount01: '美金金额',
    amount02: '原币金额',
    currencyCode: '原币',
    rpType: '收支类别',
    isHappen: '是否发生',
    invoiceType01: '单据类别',
    sameCharterVoyage: '同租家航线',
    exportAll: '导出全部',
    exportPayAmount: '导出应收款',
    submitVoyageCollApprove: '提交航次应收审批',
    searchVoyageCollApprove: '查看航次应收审批',
    submitVoyagePayApprove: '提交航次实收审批',
    searchVoyagePayApprove: '查看航次实收审批',
    voyageFee: '航次费用',
    recipientPayerTime: '收/付款截止日期',
    recipientPayer: '收/付款人',
    disCountryCode: '卸港国家',
    lodCountryCode: '装港国家',
    searchType: '查询方式',
    distance01: '航行里程',
    pasXiazhiCnt: '通過虾峙門航道',
    pasLaotieshanCnt: '通過老鐵山水道',
    pasSingaporeSt: '通過新加坡海峽',
    pasHormuzSt: '通過霍爾木茲海峽',
    pasGulfAden: '通過亚丁灣',
    pasSuezCnt: '通過蘇伊士運河',
    pasNorthindiaSea: '通過印度洋危險區',
    anyCargoclaimCase: '貨損事故',
    month1: '一月',
    month2: '二月',
    month3: '三月',
    month4: '四月',
    month5: '五月',
    month6: '六月',
    month7: '七月',
    month8: '八月',
    month9: '九月',
    month10: '十月',
    month11: '十一月',
    month12: '十二月',
    lodCountryNameEn: '装货国家',
    lodArrivalTime: '装货抵港时间',
    lodDepartureTime: '装货卸港时间',
    disCountryNameEn: '卸货国家',
    disArrivalTime: '卸货抵港时间',
    disDepartureTime: '卸货卸港时间',
    seaWaterDensity: '水密度',
    berthAnchorageName: '泊位',
    tcCount: '完成TC航次数',
    tctCount: '完成TCT航次数',
    vcCount: '完成VC航次数',
    fixCount: '完成修船航次数',
    poolCount: '完成POOL航次数',
    portCount: '挂港个数',
    lodPortCount: '挂装港个数',
    disPortCount: '挂卸港个数',
    bukPortCount: '挂加油港个数',
    repPortCount: '挂修理港个数',
    onePointCount: '过运河次数',
    twoPointCount: '过特殊点次数',
    weightDistance: '重载里程',
    emptyDistance: '空载里程',
    cargoQty02: '总货运量',
    avgCargoQty: '航次平均货载量',
    turnOver01: '货运周转量',
    allCount: '完成航次数',
    voyageDay: '运营天',
    grtInit: '载重吨',
    controlType: '控制方式',
    spsType: '境内外',
    lodCountryName: '出口国',
    disCountryName: '进口国',
    cargoGroup01: '货类大类',
    cargoQty01: '货运量',
    cargoQtyPercentage: '货量百分比',
    turnOverPercentage: '周转量百分比',
    voyageType01: '租船类型',
    voyageNum: '航次数',
    typeOrRoute: '船型/航线',
    shipOrMonth: '月份/船型',
    onMonth: '按月份',
    onShip: '按船型',
    ownerShip: '自有船/租入船',
    statisticCaliber: '统计口径',
    statisticYear: '统计年份',
    totalAvgRpm: '平均转速(转)',
    avgSpd01: '平均航速(节)',
    slip: '滑失率',
    runHrs: '航行时间',
    runDist: '航行里程',
    windDirection: '风向',
    windScale: '风力',
    waveDirection: '浪向',
    waveHeight: '浪级',
    swellDirect: '涌向',
    swellHeight: '涌级',
    visibilitysCale: '能见度(级)',
    acFoHighAndLow: '耗重油(H/L)',
    acMgoHighAndLow: '耗轻油(H/L)',
    acWater: '耗淡水',
    robFoHighAndLow: '存重油(H/L)',
    robMgoHighAndLow: '存轻油(H/L)',
    robWater: '存淡水',
    nextPortNameEn: '预抵下港名称',
    disNextPort: '距下港里程',
    etaNextPortLoc: '抵港时间',
    specialPoint1: '特殊点1',
    estArrivalTm1: '预计到达时间',
    ataArrivalTm1: '实际通达时间',
    specialPoint2: '特殊点2',
    estArrivalTm2: '预计到达时间',
    ataArrivalTm2: '实际通达时间',
    crs: '航向',
    isInReport: '是否入库',
    cancleAbandon: '取消报文废弃',
    agingDays: '账龄',
    feeStatus: '费用状态',
    feeSettingRemind: '费用设置提醒',
    inPortDetail: '在港动态明细',
    inPortInfo: '在港动态信息',
    viscosity: '黏度值',
    sulfurQty: '含硫量（%）',
    consumeMgo: '耗轻油(高/低)',
    consumeFo: '耗重油(高/低)',
    storeMgo: '存轻油(高/低)',
    storeFo: '存重油(高/低)',
    avgSpd: '航速',
    height: '浪力',
    waveDir: '浪向',
    scale: '风力',
    direction: '风向',
    avgRevolutionPerMin: '转速',
    longitude: '经度',
    latitude: '纬度',
    reportTm: '报文时间',
    type: '报文类型',
    reportStatus: '报文状态',
    noCheck: '不校验',
    portStatus: '状态',
    escrowShipOwnerTo: '代管船船东往来',
    escrowVoyageType: '代管船航次类型',
    offsetCompany: '费用承担公司',
    docNo: '订单号',
    updateVesselName: '修改船名',
    portKnowledgeBase: '港口知识库信息',
    portNotHasTimeZone: '请先维护该港口的时区',
    countFuelConsumeSuccess: '计算燃油消耗成功',
    countFuelConsume: '计算燃油消耗',
    oilCalRate: '燃油计算比例',
    portInformation: '装卸港信息',
    isReceivedNotDel: '该燃油已签收无法删除',
    specialStatus: '特殊状态',
    sailStatus: '航行状态',
    captainLock: '锁定船长报数',
    hsfoQuantity: '高硫重油库存量',
    lsfoQuantity: '低硫重油库存量',
    hsmgoQuantity: '高硫轻油库存量',
    lsmgoQuantity: '低硫轻油库存量',
    captainLockSuccess: '锁定船长报数成功',
    captainLockFail: '锁定船长报数失败',
    fuelStockNoonQuantity: '燃油库存(午报)查询',
    captainUnLock: '反锁定船长报数',
    captainUnLockSuccess: '反锁定船长报数成功',
    captainUnLockFail: '反锁定船长报数失败',
    finalLock: '锁定最终报数',
    finalLockSuccess: '锁定最终报数成功',
    finalLockFail: '锁定最终报数失败',
    finalUnLock: '反锁定最终报数',
    finalUnLockSuccess: '反锁定最终报数成功',
    finalUnLockFail: '反锁定最终报数失败',
    messagrAB: '取消航次结束成功',
    cancelInReport: '取消报文入库',
    messageSpeed: '超低速状态修改成功',
    messageSpeedB: 'CUT_OUT录入项修改成功',
    messageSpeedC: 'LOI状态修改成功',
    messageSpeedD: '内部转租合同状态修改成功',
    cdmAutoReport: '报文自动入库配置',
    hasIsAuto: '存在已经自动入库的,无法自动入库',
    hasIsNotAuto: '存在已经没有自动入库的,无法取消自动入库',
    autoSuccess: '自动入库成功',
    autoCancelSuccess: '取消自动入库成功',
    autoFail: '自动入库失败',
    autoCancelFail: '取消自动入库失败',
    vesselCode: '船舶代码',
    vesselNameEn: '船舶英文名',
    vesselNameCn: '船舶中文名',
    autoReport: '自动入库',
    cancelAutoReport: '取消自动入库',
    isAuto: '是否自动入库',
    tipsPortEvent: '港口名称或者国家其中一项必填',
    remark02: '维护内容',
    title: '标题',
    fuelConfirmation: '燃油确认',
    fuelConfirmationSuccess: '燃油确认成功',
    fuelConfirmationFail: '燃油确认失败',
    fuelRollback: '燃油回退',
    fuelRollbackSuccess: '燃油回退成功',
    fuelRollbackFail: '燃油回退失败',
    mustReceivedInitOil: '初始化油未签收，无法新增',
    hasCodeNotCommon: '存在业务场景不同的杂费',
    hasTypeNotCommon: '存在合同类型不同的杂费',
    initPortNotDel: '初始化港口无法删除',
    codeIsNotCommon: '存在业务场景代码不一致的情况，无法生成',
    saveWarning: '保存成功',
    newShipName: '船舶名称',
    //saveWarning:'保存成功',
    pleaseChooseContract: '请选择合同',
    vcContract: 'VC合同',
    tcContract: 'TC合同',
    poolContract: 'POOL合同',
    arrivalNotDel: '已经实际抵港无法删除',
    limitTwoMessage: '最多添加二条',
    haveInContractTip: '已经存在租入船合同，无法导入',
    haveOutContractTip: '已经存在租出船合同，无法导入',
    mustOboContractTip: '只允许添加OBO合同',
    noOboContractTip: '只允许添加租出船合同',
    tips: '提示',
    isReceived: '是否签收',
    receivedSuccess: '签收成功',
    receivedFail: '签收失败',
    isNotReceived: '是否反签收',
    notReceivedSuccess: '反签收成功',
    notReceivedFail: '反签收失败',
    startPortAndOilDetail: '开始港口以及存油情况',
    editOilDetail: '初始化存油修改',
    sign: '签收',
    noSign: '反签收',
    voyagePlane: '航次执行',
    voyageTime: '航次时间',
    oneContract: '船舶调度管理',
    pleaseAssContract: '请先关联合同',
    pleaseAssVcOutContract: '请先关联VC-OUT合同',
    editRate: '运价编辑',
    messageD: '请选择要删除的数据',
    unitPrice4: '价格',
    noSpecialSuccess: '无特殊事件登记成功',
    noSpecialFail: '无特殊事件登记失败',
    payId: '支付方',
    hasAudited: '存在状态为已审核，无法删除',
    lockSuccess: '锁定成功',
    unLockSuccess: '反锁定成功',
    lockFail: '锁定失败',
    unLockFail: '反锁定失败',
    unLock: '反锁定',
    lock: '锁定',
    exportError: '已导入数据不可重复导入',
    opsError: '请选择同一收款人、同一币种',
    warningPleaseSelect02: '船舶已经抵港，或第一个港口不可以插入港口',
    errorVoyage: '请先维护航次货载信息,或者航次货载信息中存在卸货港为空,否则取不到提单货量',
    textTitle: '航次货载信息',
    handleVoyageEndOpen: '取消航次结束',
    freightRate: '运价费率',
    priceOne: '单价',
    messagrA: '航次结束成功',
    messagrB: '租出船请先还船',
    messagrC: '存在需要交还船的合同没有进行交船操作',
    portMessage1: '所有港口需要实际抵港和实际离港',
    portMessage2: '',
    ExpenseitemOne: '滞期费',
    ExpenseitemTwo: '已计算滞期费',
    voyageRemarkOne: '航次备注信息新增',
    successpre: '航次切换成功',
    addSpace: '新增',
    deleteSpace: '删除',
    remorkSpac: '特殊事件记录',
    evebtDetail: '事件详情',
    exemptConType: '豁免油耗保证',
    extraTimeFlag: '额外时间(天)',
    extraCon: '额外油耗(吨)',
    EndSpac: '结束时间',
    beginTimeSpac: '开始时间',
    makeDateTime: '记录日期',
    evebtType: '事件类型',
    specialDetail: '特殊事件明细',
    retiredSuccess: '退役成功',
    retiredFail: '退役失败',
    addBillOfLoading: '提单新增',
    searchTemplate: '查询提单模板',
    addTemplate: '新增提单模板',
    noSpecial: '无特殊事件确认',
    cancelNoSpecial: '取消无特殊事件确认',
    cancelNoSpecialSuccess: '取消无特殊事件确认成功',
    cancelNoSpecialFail: '取消无特殊事件确认失败',
    specialEventRecords: '特殊事件记录',
    shijiButton: '锁定预计信息',
    shijiButtonOpen: '解锁预计信息',
    acButton: '锁定实际信息',
    acButtonOpen: '解锁实际信息',
    actTotalOffhire: '实际总扣减费用',
    actTotalOil: '实际油耗损失',
    actTotalRent: '实际扣减租金',
    actOffHireDays: '实际停租天',
    estOffHireDays02: '预计停租天',
    actDateOne: '实际结算时间',
    estTotalOffhire: '预计总扣减费用',
    estTotalRent: '预计油耗损失',
    estDailyRent: '预计扣减租金',
    estOffHireDays: '预计计算停租天',
    ballastTime: '空放耗时',
    ballastMile: '空放里程',
    estDate: '预计结算日期',
    dailyRent: '日租金(GROSS)',
    proRate: '停租天计算比例',
    oilType: '燃油类型',
    totalConsume: '油耗',
    priceOil: '价格',
    // totalFee:
    messageTips: '只有未导入并且未提交才能进行废弃',
    //proRate:'停租天计算比例',
    //dailyRent:'日租金',
    // estDate:'预计结算日期',
    offhireDays: '计算停租天数',
    ttlRent: '',
    discardSuccess: '废弃成功',
    discardFail: '废弃失败',
    examineSuccess: '审核成功',
    examineFail: '审核失败',
    reverseExamineSuccess: '反审核成功',
    reverseExamineFail: '反审核失败',
    upSuccess: '港口上移成功',
    downSuccess: '港口下移成功',
    notLastTips: '该港口为航次最后一个港口，不能下移',
    preIsArrTips: '上一个港口非预估港口不能上移',
    isArrTips: '实际抵港，不能调整',
    notFirstTips: '该港口为航次第一个港口，不能上移',
    settleStatus: '付款',
    paymentApplicationId: '备用金',
    checkFlag: '审核',
    baseAmount: '美元金额',
    amount01: '预估金额',
    currencyName: '币种',
    an: '代理',
    relatedParties: '相关方评价',
    noticeEstimateTrue: '通知代理填报预估单',
    portFeeEstimateTrue: '已预估港口使费',
    portFeeEstimate: '港口使费预估',
    warningPleaseSelect: '请先选择一条数据',
    warningSelectOne: '只能选择一条',
    localAgentSetCenter: '本地代理做结算中心',
    editAgentInfo: '编辑代理信息',
    owner: 'Owner',
    charterer01: 'charterer',
    subCharterer: 'sub-Charterer',
    chrgName: '联系方式',
    agentFeePay: '代理支付方',
    agentBy: '代理指定方',
    agentType: '代理类型',
    agentName: '结算中心',
    localAgentName01: '当地代理',
    localAgentName: '代理名称',
    agentInfo: '代理信息',
    portCode02: '港口',
    portCode01: '港口代码',
    days: 'Days',
    portAgentDetail: '港口代理明细',
    codeInShipLine: '代码',
    enNameInShipLine: '英文名',
    compLt: '航次结束',
    ispFleetCode: '船队',
    shipRepairDedInfo: '修船扣减信息',
    fuelLossInformation: '燃油损耗信息',
    rentLossInformation: '租金损失信息',
    loseOffHire: '停租停航损失信息',
    isBunker: '油耗损失计入营运账户',
    isOffHireDays: '计入非营运天',
    isOffHire: '租金损失计入营运账户',
    beginDoH: '开始高硫轻油',
    beginDoL: '开始低硫轻油',
    beginFoH: '开始高硫重油',
    beginFoL: '开始低硫重油',
    endDoH: '结束高硫轻油',
    endDoL: '结束低硫轻油',
    endFoH: '结束高硫重油',
    endFoL: '结束低硫重油',
    north: '北',
    south: '南',
    west: '西',
    east: '东',
    beginLat: '开始纬度',
    beginLong: '开始经度',
    beginTime_LT: '开始时间(LT)',
    beginTimeZone: '时区',
    beginTime_GMT: '开始时间(GMT)',
    beginPortCode: '开始港口',
    endLat: '结束纬度',
    endLong: '结束经度',
    endTime_LT: '结束时间(LT)',
    endTimeZone: '时区',
    endTime_GMT: '结束时间(GMT)',
    endPortCode: '结束港口',
    startPortInformation: '开始港口信息',
    endPortInformation: '结束港口信息',
    estimateLockUser: '锁定人',
    estimateLockTime: '锁定时间',
    actualLockUser: '锁定人',
    actualLockTime: '锁定时间',
    shipRepairLocale: '修船地点',
    actualInfo: '实际信息',
    estimatedInfo: '预计信息',
    offHireAndOffFlightInfo: '停租停航信息',
    offHireAndOffFlightMaintain: '停航停租明细',
    day: '天数',
    beginDate: '开始',
    endDate: '结束',
    reportTime: '报告时间',
    cause: '停租类型',
    startTime02: '开始时间',
    endTime02: '结束时间',
    speed02: '航速',
    speedType: '航速类型',
    isPayByOtherDept: '由其他部门安排支付',
    toComm: '佣金',
    advanceAmount: '代垫金额',
    invoiceNo: '发票号',
    invoiceDate: '发票日期',
    stockStatus: '签收入库状态',
    flowTime: '流水时间',
    batchNo: '涉及批次',
    quantity: '油量',
    bunkerSpec: '油种',
    operationType: '操作',
    operationNo: '操作号',
    submitBusiness: '审核',
    discard: '废弃',
    riskScreening: '风险筛查',
    shipMaintenance: '船舶维修',
    shipAccident: '船舶事故',
    offHireAndOffFlight: '停租停航',
    portKnowledge: '港口知识库',
    shipSpeed: '航速指令',
    voyageAccount: '航次船帐',
    voyageSundryFee: '航次杂费',
    voyageSundryFeeMaintain: '航次杂费维护',
    message: '报文',
    fuelStock: '燃油库存',
    abandon: '状态',
    toArap: '应收应付',
    toFrt: '导入发票',
    toArap02: '提交应收应付',
    toFrt02: '导入租金运费发票',
    examine: '审核',
    reverseExamine: '反审核',
    advance: '代垫',
    payDeadline: '付款截止日期',
    payee: '收款人',
    pay: '付款人',
    amountInVoyage: '金额',
    describe: '描述',
    feeType: '费用类型',
    feeType2: "<label style='color:red'>*</label> 费用类型",
    rpFlag: '收/付',
    addWaterRemark: '加水备注',
    currencyInWater: '币种',
    actualQuantityWater: '实际数量',
    cashPay: '现金支付',
    portPay: '港口使费垫支',
    my: '我方',
    other: '其他方',
    addWaterPort: '加水港',
    addFoTime: '加油水日期',
    addFoQuantity: '加重油量（高/低硫）',
    foPrice: '重油价格（高/低硫）',
    addMgoQuantity: '加轻油量（高/低硫）',
    mgoPrice: '轻油价格（高/低硫）',
    addWaterQuantity: '加水量',
    waterPrice: '水价格',
    totalFee: '总费用',
    spContractNo: '现货合同号',
    approveStatus: '审批状态',
    approveNo: '审批单',
    addOilAndWater: '加油水信息',
    addWaterDetail: '加水信息明细',
    addOilDetail: '加油信息明细',
    addWaterInfo: '加水信息明细',
    addOil: '加油',
    addWater: '加水',
    dispatchingManagement: '调度管理',
    vesselFuelManagement: '船舶燃油管理',
    fuelFuturesContract: '燃油期货合同',
    fleet: '船队',
    prVesselName: '船名',
    vessel: '船舶',
    prVesselNameInDetail: '拟加油船舶',
    contractNo: '合同号',
    supplierName: '供应商',
    traderName: '贸易商',
    supplierRemarks: '供应商备注',
    oilNameAndSpec: '油种',
    contractDate: '合同日期',
    orderDate: '订油日期',
    number: '序号',
    actualRefuelingDate: '实际加油日期',
    fuelFuturesContractDetail: '燃油期货合同明细',
    contractInfo: '合同信息',
    contractName: '合同名称',
    basicInformation: '基础信息',
    placeholder: '请输入',
    placeholderSelect: '请选择',
    prPortName: '拟加油港口',
    portName: '加油港',
    contType: '合同类型',
    contStatus: '合同状态',
    effectDate: '生效时间',
    shipTeam: '船型团队',
    vesselType: '船型',
    estRDate: '拟加油日期',
    startDatePlaceHolder: '开始日期',
    endDatePlaceHolder: '结束日期',
    remark: '备注',
    contractNumberAndPrice: '合同数量及价格',
    unitPrice: '单价',
    unitPrice2: '<label style=\'color:red\'>*</label> 单价',
    oilTypeName: '油种',
    oilTypeName2: "<label style='color:red'>*</label> 油种",
    oilSpec: '型号',
    oilSpec2: "<label style='color:red'>*</label> 型号",
    oilQuantity: '油量（吨）',
    oilQuantity2: '<label style=\'color:red\'>*</label> 油量（吨）',
    fuelCharge: '加油量',
    oilFloating: '浮动量（%）',
    oilFloating2: '<label style=\'color:red\'>*</label> 浮动量（%）',
    amount: '小计',
    // 货代大副收据明细界面
    //     基本信息表
    mateReceiptEdit: '大副收据编辑',
    soNo: '大副收据编号',
    carrier: '承运人',
    vesselName: '船名',
    voyageNo: '航次',
    shipperDesc: '发货人描述',
    consigneeDesc: '收货人描述',
    notifyDesc: '通知人描述',
    pol: '装港',
    pod: '卸港',
    marks: '唛头',
    noOfPackage: '件数',
    packageType: '包装类型',
    grossWeight: '毛重',
    weightUnit: '重量单位',
    goodsCube: '体积',
    cubeUnit: '体积单位',
    goodsDesc: '货描',
    deckDesc: '甲板货批注',
    mateRemark: '大副批注',
    loadingDate: '装船时间',
    isLocked: '是否锁定',
    createdBy: '创建人',
    createdDate: '创建时间',
    updatedBy: '修改人',
    updatedDate: '修改时间',
    seqNo: '序号',
    blNo: '提单号',
    attachmentInfo: '附件信息',
    no: '序号',
    attchmentType: '附件类型',
    attchmentName: '附件名称',
    uploadDate: '上传时间',
    uploadDept: '上传部门',
    uploadUser: '上传人',
    refresh: '刷新',
    baseInformation: '基本信息',
    chartererCode: '租家代码',
    chartererName: '租家名称',
    creator: '创建人',
    createTime: '创建时间',
    lastModifyBy: '修改人',
    lastModifyTime: '修改时间',
    associateBl: '关联提单',
    errorMessage: '请重试',
    errorSoNo: '该大副收据编号已存在，不能保存',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    isSureCancel: '是否确定作废',
    soDeleteCheck: '该大副数据已锁定，不能删除',
    copyBlTitle: '指定提单格式',
    // 提单跟踪-提单保函管理页面
    blTracking: '提单跟踪',
    blLoiManagement: '提单保函管理',
    isOwnerFlag: '是否自有船',
    blReceivedFlag: '是否收到正本提单',
    isLitigation: '是否在诉讼时效之内',
    billReceiptTime: '提单收到时间',
    guaranteeReceiptTime: '保函收到时间',
    litigationPeriod: '诉讼时效（月份）',
    litigationPeriod2: '无单放货诉讼时效（月）',
    litigationEndTime: '诉讼时效截止',
    litigationFlag: '是否在诉讼时效之内',
    litigationMaintenance: '诉讼期维护',
    litigationTitle: '诉讼期维护',
    voyageGuaranteeLetter: '航次保函管理',
    countryCode: '国家/地区代码',
    countryNameCn: '国家/地区中文名',
    countryNameEn: '国家/地区英文名',
    charterer: '租家',
    loiQty: '保函数量',
    loiType: '保函类型',
    isobrand: 'ISO燃油等级',
    approvalStatus: '审批状态',
    voyageBlLoi: '航次提单保函',
    loiDate: '保函日期',
    relatedContract: '关联合同',
    blLoiEdit: '提单保函编辑',
    submitForApproval: '提交审批',
    viewImages: '查看影像文件',
    otherInfo: '其他信息',
    approvalHistory: '历史审批意见',
    goodsCondition: '货物相关数据情况',
    blSubmitCheck: '该提单审批状态未审批通过，无法操作',
    // approvalHistory: '历史审批意见',
    updateTime: '更新收到时间',
    checkSoNo: '查看大副收据',
    checkBlNo: '查看提单',
    checkContractNo: '查看合同号',
    invalidFlag: '是否作废',
    loiConfirmFlag: '是否确认保函',
    relatedContractFlag: '是否已关联合同号',
    releasedFlag: '是否放单',
    retakeFlag: '是否提单回收',
    selectOneData: '请选中一条信息',
    noSoNo: '该大副收据不存在',
    noBlNo: '该提单不存在',
    noContractNo: '该合同号不存在',
    modifyOriginReceivedDate: '更新正本回收时间',
    operationSuccessful: '操作成功',
    operationFailed: '操作失败',
    selectInvoiceType: '请选择发票类型',
    // 提单保函流程监控页面
    loiProcess: '提单保函流程监控',
    voyageType: '航次类型',
    cargoClass: '货类',
    cargoGroup: '货种',
    voyageEndTime: '航次完成时间',
    blRecallEmail: '提单回收催收邮件',
    cargoQuantity: '货量',
    discPort: '卸港',
    ataFirst: '抵第一卸港时间',
    loiApprovalStatus: '保函审批状态',
    loiBuildDate: '生成保函日期',
    email: '邮件',
    send: '发送',
    addressee: '收件人',
    carbonCopy: '抄送',
    subject: '主题',
    blApprovalStatus: '提单审批状态',
    // 正本提单回收统计（按照船型）
    oblStatisticsCustomer: '正本提单回收统计(按客户)',
    labStaticShip: '正本提单回收统计(按船型)',
    dateTimeStatic: '时间',
    customer: '客户',
    voyageQty: '总航次数',
    voyageEndTimeFr: '航次完成时间从',
    voyageEndTimeTo: '航次完成时间到',
    loiReceivedVoyageQty: '正本提单全部收回-航次数',
    loiUnreceivedVoyageQty: '正本提单未全部收回-航次数',
    receivedRate: '正本提单回收率(%)',
    isExistVesselAndVoyage: '该船名航次已存在提单模板，不能保存',
    save: '保存',
    uploadAttachments: '上传附件',
    effectivenessOfContract: '合同生效',
    endOfContract: '合同结束',
    contractNumber: '合同编号',
    contractQuantityAndPrice: '合同数量及价格',
    unitPriceCompany: '<label style=\'color:red\'>*</label> 单价(元/吨)',
    marketOilPrice: '市场油价',
    highSulfurHeavyOil: '高硫重油',
    lowSulfurHeavyOil: '低硫重油',
    highSulfurLightOil: '高硫轻油',
    lowSulfurLightOil: '低硫轻油',
    shipRefueling: '船舶加油',
    refuelingTime: '加油时间',
    balance: '结余',
    enclosure: '附件',
    fileName: '文件名',
    fileType: '文件类型',
    fileSize: '文件大小',
    refuelingQuery: '加油查询',
    payer: '支付方',
    payType: '支付方式',
    emergencyProcurement: '紧急采购',
    actualRefuelingdateFrom: '实际加油日期（起）',
    actualRefuelingDateEnd: '实际加油日期(止)',
    traders: '贸易商',
    spotContractNo: '现货合同号',
    oilOrderingDateFrom: '订油日期（起）',
    oilOrderingDateEnd: '订油日期（止）',
    futuresContract: '期油合同',
    isFutures: '是否使用期油',
    futuresDate: '期货日期',
    whetherFuturesOil: '是否期货油',
    ownShip: '自有船',
    charterShip: '租入船',
    voyageNumber: '航次号',
    operatingCompany: '经营公司',
    signFor: '签收',
    portName02: '港口名称',
    country: '国家',
    fuelAndHeavyOilSupplier: '燃油重油供应商',
    fuelAndLightOilSupplier: '燃油轻油供应商',
    orderingDate: '订油日期',
    estimatedDate: '预计日期',
    actualDate: '实际日期',
    createdOn: '创建日期',
    dateOfReceiptOfInvoice: '收到发票日期',
    businessApprovalCompleted: '业务审批完成日期',
    actualPaymentDate: '实际付款日期',
    totalCost: '总费用',
    actualAmountHighsulfurHeavyOil: '实际加高硫重油量',
    actualHighSulfurHeavyOilPrice: '实际高硫重油价格',
    actualAmountLowsulfurHeavyOilAdded: '实际加低硫重油量',
    actualLowSulfurHeavyOilPrice: '实际低硫重油价格',
    actualAmountHighSulfurLightOilAdded: '实际加高硫轻油量',
    actualHighSulfurLightOilPrice: '实际高硫轻油价格',
    actualAmountLowSulfurLightOilAdded: '实际加低硫轻油量',
    actualLowSSulfurLightOilPrice: '实际低硫轻油价格',
    estimatedAmountHighSulfurHeavyOil: '预计加高硫重油量',
    estimatedAmountLowSulfurJeavyOil: '预计加低硫重油量',
    estimatedAmountHighSulfurLightOil: '预计加高硫轻油量',
    estimatedAmountLowSulfurLightOilAdded: '预计加低硫轻油量',
    marketPriceOfHighSulfurHeavyOil: '市场高硫重油价格',
    marketPriceOfLowSulfurHeavyOil: '市场低硫重油价格',
    marketPriceOfHighSulfurLightOil: '市场高硫轻油价格',
    marketPriceOfLowSulfurLightOil: '市场低硫轻油价格',
    highSulfurHeavyOilPriceInSingaporeMarket: '新加坡市场高硫重油价格',
    lowSulfurHeavyOilPriceInSingaporeMarket: '新加坡市场低硫重油价格',
    highSulfurLightOilPriceInSingaporeMarket: '新加坡市场高硫轻油价格',
    lowSulfurLightOilPriceInSingaporeMarket: '新加坡市场低硫轻油价格',
    termOilContractNo: '期油合同号',
    termOilContractDate: '期油日期',
    invoice: '发票',
    printRefuelingBulkCargo: ' 打印加油申请单（散货）',
    printRefuelingGroceries: '打印加油申请单（件杂货）',
    registerActualPaymentDate: '登记实际付款日期',
    printPaymentApplicationForm: '打印付款申请单',
    submitFinancialPayment: '提交财务付款',
    evaluateSuppliers: '评价供应商',
    fuelApproval: '燃油审批',
    approvalList: '审批列表',
    lockFuelReceipt: '锁定燃油签收',
    lockFuelReceiptLocal: '锁定燃油签收（本地）',
    refuelingApplication: '加油申请',
    Read: '已阅读',
    refuelingVoid: '加油作废',
    feeRegistration: '费用登记',
    voyageInformation: '航次信息',
    HighLowSulfurHeavyOil: '高/低硫重油',
    HighLowSulfurLightOil: '高/低硫轻油',
    futuresOilPrice: '期油价格',
    totalAmountScheduledOil: '期油总价',
    totalAmountActualOilPrice: '实际油价总金额',
    totalAmountmarketOilPrice: '市场油价总金额',
    amountDifference: '金额差',
    ton: '吨',
    freshWaterStorage: '存淡水',
    purposeOfBerthing: '靠港目的',
    arrivalTime: '抵港时间',
    departureTime: '离港时间',
    prepaidOrNot: '是否代垫',
    prepaidCustomers: '代垫客户',
    invoiceType: '发票类型',
    purchaseRemarks: '采购备注',
    refuelingInformation: '加油信息',
    supplierInquiry1: '供应商1及询价',
    supplierInquiry2: '供应商2及询价',
    supplierInquiry3: '供应商3及询价',
    refuelingEventRecord: '加油事件记录',
    refuelingEvaluation: '加油评价',
    oilSupplyContract: '供油合同',
    estimatedQuantity: '预计数量(MT)',
    actualQuantity: '实际数量(MT)',
    sulfurContent: '含硫量%',
    viscosityValue: '粘度值',
    receiptPrice: '入库价$/MT',
    paymentStatus: '付款状态',
    actualSupplierLightOil: '轻油实际供应商',
    refuelingType: '加油操作',
    refuelingNature: '加油类型',
    viewFuturesContracts: '查看期货合同',
    supplierAndPriceRefueling: '本次加油供应商及价格',
    expirationDate: '到期日期',
    actualSupplierHeavyOil: '重油实际供应商',
    otherExpenses: '其他费用',
    cost: '费用',
    costTab: '费用明细',
    independentPayment: '独立支付',
    enquiry1: '询价 1',
    enquiry2: '询价 2',
    enquiry3: '询价 3',
    eventType: '事件类型',
    responsibleParty: '责任方',
    eventDescription: '事件描述',
    voyageStatus: '航次状态',
    // 调度
    voyageTwo: '航次号',
    startTime: '航次开始时间',
    endTime: '航次结束时间',
    portListing: '挂港列表',
    route: '航线',
    dispatcherName: '调度员',
    initVoyage: '航次任务初始化',
    itemVoyageInfo: '航次信息',
    focusCode: '重点跟踪原因',
    startTitle: '开始港口及存油情况',
    arrivalTimeone: '航次开始时间',
    portCode: '开始港口',
    unit: '吨',
    actDate: '加油时间',
    price: '价格',
    titleOne: '新船航次任务初始化',
    titleTwo: '布置新航次',
    titleThree: '航次信息',
    description: '说明',
    titleDetail: '船舶调度编辑',
    register: '特殊事件登记',
    voyageRemark: '航次备注',
    Lastvoyage: '上航次',
    Nextoyage: '下航次',
    Expenseitem: '费用项',
    voyageEnd: '航次结束',
    retirement: '退役',
    addTidan: '新增提单保函',
    searchTidan: '查询提单保函',
    voyageday: '航次天',
    currency: '航次币种',
    Specialpoint: '特殊点',
    edit: '编辑',
    more: '更多',
    Domestictrade: '内贸',
    Foreigntrade: '外贸',
    VoyageIsuselowspeed: '超低速',
    VoyageIscuout: '使用CUT-OUT录入项',
    isLoI: '是否需要做LOI',
    isSublet: '内部转租合同',
    chaVygNo: '租家航次号',
    voyageIsdd: '修船航次',
    planDockingDays: '计划坞修天数',
    local: '装期(LOCAL)',
    isEscrowVoyage: '自有船代管',
    mulContractVoy: '多合同航次',
    specialTitle: '特殊点信息',
    estimatedRefuelingTime: '预计加油时间',
    shipSource: '船舶来源',
    keywordSearch: '关键字检索',
    voyagePort: '航次挂港货载',
    portName03: '港口',
    portPurpose: '抵港目的',
    distance: '里程',
    arrivalTimetwo: '抵港时间(LT)',
    aFoH: '抵港重油（高/低硫）',
    aDoH: '抵港轻油（高/低硫）',
    berthingTime: '靠泊时间',
    departureGmtTime: '离港时间',
    dFoH: '离港重油（高/低硫）',
    dDoH: '离港轻油（高/低硫）',
    consumption: '在港耗重油(高/低硫)',
    mgoPort: '在港耗轻油(高/低硫)',
    sailingTime: '航行时间',
    sailingOne: '航行耗重油(高/低硫)',
    sailingtwo: '航行耗低油(高/低硫)',
    distanceOne: 'ESOP到码头距离',
    distanceTwo: '码头到FA距离',
    portInsertion: '插入港口',
    portProxy: '港口代理',
    portUp: '港口上移',
    portMigration: '港口下移',
    portMovement: '在港动态',
    titleMessage: '航次挂港信息保存',
    havaPda: '安排使费预付',
    anchorWork: '锚地作业标识',
    havaFda: '安排使费实付',
    commGmt: '航次开始',
    compGmt: '航次结束',
    portInfo: '港口信息',
    portTime: '港口/时区',
    berthing: '靠泊',
    lastPortName: '上一个港口',
    distanceO: '港间里程',
    sailingTimeOne: '航行时间',
    speed: '平均航速',
    esopTime: 'ESOP',
    aBefDrf: '船艏吃水',
    aMidDrf: '船舯吃水',
    aAftDrf: '船艉吃水',
    aBefDrfOne: '船艏吃水',
    aMidDrfOne: '船舯吃水',
    aAftDrfOne: '船艉吃水',
    aDaOne: '水密度',
    aWater: '水',
    aWaterone: '水',
    highSulfurHeavyOilOne: '高硫重油',
    lowSulfurHeavyOilOne: '低硫重油',
    highSulfurLightOilOne: '高硫轻油',
    lowSulfurLightOilOne: '低硫轻油',
    highSulfurHeavyOilTne: '高硫重油',
    lowSulfurHeavyOilTne: '低硫重油',
    highSulfurLightOilTne: '高硫轻油',
    lowSulfurLightOilTne: '低硫轻油',
    highSulfurHeavyOilne: '高硫重油',
    lowSulfurHeavyOilne: '低硫重油',
    highSulfurLightOilne: '高硫轻油',
    lowSulfurLightOilne: '低硫轻油',
    ahighSulfurHeavyOilne: '高硫重油',
    alowSulfurHeavyOilne: '低硫重油',
    ahighSulfurLightOilne: '高硫轻油',
    alowSulfurLightOilne: '低硫轻油',
    aDa: '水密度',
    aEl: '主机滑油',
    aGl: '辅机滑油',
    aCl: '气缸滑油',
    departureTimeOne: '离港',
    dEl: '主机滑油',
    dGl: '辅机滑油',
    dCl: '气缸滑油',
    faTime: 'FA',
    voyageMount: '航次挂港',
    voyageCargo: '航次货载',
    totalNumber: '提单数量',
    portCodenew: '装货港',
    tFportCode: '卸货港',
    cargoName: '货物名称',
    loadQty: '装货货量',
    contractQty: '预计货量',
    unloadQty: '卸货货量',
    turnover: '周转量',
    Charterer: '租家',
    goodsInfo: '货物信息',
    goodsDetail: '航次货物明细',
    originArea: '原产地',
    cargoQty: '提单货量',
    blDate: 'B/L日期',
    contractQtyOne: '合同货量',
    blNoO: '提单编号',
    lgNo: '保函编号',
    heatingCargo: 'HEATING CARGO',
    temp: '华氏温度',
    portCodeOne: '装货港口',
    portCodetwo: '卸港港口',
    perDisQty: '卸前货量',
    tiaokuan: '运费条款',
    refuelingApply: '加油申请',
    contractOne: '我方合同',
    contractTwo: '代管合同',
    contractTypeIn: '合同类型',
    aDelTime: '交船时间',
    aRedTime: '还船时间',
    returnButton: '实际还船',
    handButton: '实际交船',
    estHandShip: '预计交船',
    actHandShip: '实际交船',
    estReturnShip: '预计还船',
    actReturnShip: '实际还船',
    relectContract: '关联合同信息',
    haveChange: '可供选择',
    alreadyHave: '已选择',
    outContract: '租出船合同',
    nameContract: '明华国际/新加坡合同',
    sureButton: '确认导入',
    close: '取消',
    returnShip: '预计还船',
    handShip: '实际还船',
    yuan: '元',
    eRedHfoPrice: '高硫重油价格',
    eRedLfoPrice: '低硫重油价格',
    eRedHdoPrice: '高硫轻油价格',
    eRedLdoPrice: '低硫轻油价格',
    eRedPorts: '还船时间/地点',
    eRedRemark: '还船备注',
    cpNotice: '预计还船时间',
    cpNoticeDesc: '备注',
    returnActual: '实际还船(船长报数)',
    returnLast: '实际还船(最终报数)',
    aRedTimeLt: '还船时间(LOC)',
    aRedTimeOne: '还船时间(GMT)',
    aRedPort: '还船港口/地点',
    actualRe: '实际还船(最终报数)',
    waring: '说明:假如最终报数与船长报数不一致，则需要填写最终报数，否则不需要',
    returnOil: '还船后加油出库',
    returnOilBack: '撤回还船后加油出库',
    returnShipDeliver: '预计交船',
    handShipDeliver: '实际交船',
    eDelPorts: '交船时间/地点',
    eDelRemark: '交船备注',
    cpNoticeOne: '预计交船时间',
    returnActualDeliver: '实际交船(船长报数)',
    returnActualDeliverLast: '实际交船(最终报数)',
    aDelTimeLt: '交船时间(LOC)',
    aDelTimeOne: '交船时间(GMT)',
    aDelPort: '交船港口/地点',
    contractTitle: '航次货载合同运价及货量维护',
    freightType: '计费类型',
    freightFee1: '运价',
    calType: '货物计算方式',
    contracthuo: '合同货量',
    tonyi: '吨以上',
    cargoOqMin: '超出货量',
    cargoOqStandards: '计费标准',
    warningNote: '*如果有关明华国际/新加坡合同，则同时修改',
    actual: '实际',
    anticipate: '预计',
    messageVoyageNo: '新船，请到新船航次任务初始化处布置航次任务！',
    messageTwoVoyageNo: '新航次任务初始化只能布置自有船',
    TimeInPort: '在港时间',
    exportSuccess: '导入成功',
    limitMessage: '只能添加一条',
    actualSupplier: '实际供应商',
    fuelFeeRegistration: '燃油费用登记',
    invoiceDocument: '发票/单据号',
    invoiceDocumentNo: "发票/单据",
    costDescription: '费用说明',
    invoiceAmount: '发票金额',
    dueDate: '到期日',
    submitFlag: '是否提交应收应付',
    submitFlag02: '是否提交应收',
    payee02: '收款方',
    fuelCostInformation: '燃油费用信息',
    registerReceiptDateInvoice: '登记收到发票日期',
    updateDate: '更新',
    refuelingPort: '加油港口',
    payer02: '付款单位',
    oilSupplier: '供油商',
    refuelingContract: '加油合同',
    receiptComplete: '单据收齐',
    expensesAndReceipts: '收支',
    expensesAndReceipts2: "<label style='color:red'>*</label> 收支",
    isIncludesTax: '价格是否含税',
    isIncludesTax2: "<label style='color:red'>*</label> 价格是否含税",
    taxRate: '税率',
    taxRate2: "<label style='color:red'>*</label> 税率",
    invoiceQuantity: '发票数量',
    invoiceQuantity2: "<label style='color:red'>*</label> 发票数量",
    invoiceUnitPrice: '发票单价',
    invoiceUnitPrice2: "<label style='color:red'>*</label> 发票单价",
    financialApportionmentAmount: '财务摊分金额',
    purchaseQuantity: '采购数量',
    purchaseUnitPrice: '采购单价',
    purchaseAmount: '采购金额',
    fuelInformation: '燃油信息',
    settlementObject: '结算对象',
    ourClearingCompany: '我方结算公司',
    fuelContractNumber: '燃油合同号',
    withdrawalFuelReceipt: '撤回燃油签收',
    pricingMethod: '计价方式',
    generatePreReport: '创建预结算报告',
    generateSettlementReport: '创建结算报告',
    viewPreReport: '查看预结算报告',
    viewSettlementReport: '查看结算报告',
    generatePreConfirm: '是否确认生成预结算报告？',
    generateSettlementConfirm: '是否确认生成结算报告',
    shipManager: '船舶负责人',
    charteringName: '租船业务员'
  },
  routeInCommonData: {
    route: '航线',
    fleet: '船队',
    keyword: '关键词',
    code: '代码',
    enName: '英文名',
    cnName: '中文名',
    inFleet: '适用船队',
    shippingLineType: '航线类型',
    tradingArea: '是否贸易航线',
    status: '状态',
    lastModifyBy: '更新人',
    lastModifyTime: '更新时间'
  },
  tor: {
    oneTitle: '调度管理',
    twoTitle: '船舶报文管理',
    inShipContract: '报文监控管理',
    leftTitle: '船舶信息',
    rightTitle: '报文信息',
    haveRu: '已入库报文',
    haveBad: '已废弃报文',
    type: '报文类型',
    errorMessage: '错误报文',
    reportTn: '报序',
    reportTm: '报文时间',
    timeZone: '录报时区',
    reportFlag: '报文录入端',
    errorInfo: '报文错误信息',
    warehousing: '入库',
    abandon: '废弃',
    mark: '标记入库',
    successWare: '入库成功',
    abandomError: '操作成功',
    cancelInSuccess: '取消入库成功',
    cancelInFail: '取消入库失败'
  },
  //报文综合查询
  allReport: {
    fleet: '船队',
    vesselName: '船舶',
    vygNo: '航次',
    reportTm: '报告时间',
    timeZone: '时区',
    reportType: '报文类型',
    reportTn: '报序',
    ngstatus: '航行状态',
    sailingStatus: '船舶状态',
    port: '港口/地点(时间)',
    crs: '航向',
    avgSpd: '平均航速(节)',
    costfoday: '24小时耗重油',
    avgRevolutionPerMin: '平均转速(转)',
    slip: '滑失率',
    runHrs: '航行时间',
    runDist: '航行里程',
    wind: '风向/风力',
    wave: '浪向/浪级',
    swell: '涌向/涌高',
    cfo: '耗重油(H/L)',
    sfo: '存重油(H/L)',
    cmgo: '耗轻油(H/L)',
    smgo: '存轻油(H/L)',
    refue: '加油',
    costmgoday: '24小时耗轻油',
    remark: '备注',
    receivedTm: '接收时间',
    reportStatus: '是否入库',
    checkStatus: '审核状态'
  }
};